import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import { BreadcrumbItemProps } from '@/features/admin/components/AdminPageHeader';
import { RosterManagementRoot } from '@/features/manage-roster/components/RosterManagementRoot';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },

  { label: 'Roster', link: { to: '/app/admin-section/roster' } },
];

export const Route = createFileRoute('/_app/app/admin-section/roster')({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function RouteComponent() {
  // Local state to help force remount roster root on org change if needed
  const [key, setKey] = useState(0);
  const forceReload = () => setKey((k) => k + 1);

  return (
    <AdminPageContent>
      <AppPageHeader breadcrumbItems={breadcrumbItems} />
      <RosterManagementRoot key={key} onReload={forceReload} />
    </AdminPageContent>
  );
}
